export const setAddressQR = obj => {
    return async (dispatch)=>{
        await dispatch({type: 'INIT_ADDRESS', payload: {...obj}})
    }
}